import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export const getActivityComparison = (request: { activity1Id: string; activity2Id: string }) => {
  const url = `${apiConfiguration.apiUrl}/activity-comparisons`;
  return axios.get<ActivityComparisonModel>(url, { params: request });
};
